! function() {
    "use strict";
    window.StyleHatch = window.StyleHatch || {}, StyleHatch.Sections = function() {
        this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:section:reorder", this._onReorder.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
    }, StyleHatch.Sections.prototype = $.extend({}, StyleHatch.Sections.prototype, {
        _createInstance: function(t, e) {
            var o = $(t),
                a = o.attr("data-section-id"),
                n = o.attr("data-section-type");
            if (void 0 !== (e = e || this.constructors[n])) {
                var i = $.extend(new e(t), {
                    id: a,
                    type: n,
                    container: t
                });
                this.instances.push(i)
            }
        },
        _onSectionLoad: function(t) {
            var e = $("[data-section-id]", t.target)[0];
            e && this._createInstance(e)
        },
        _onSectionUnload: function(t) {
            var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
            e && ("function" == typeof e.onUnload && e.onUnload(t), this.instances = slate.utils.removeInstance(this.instances, "id", t.detail.sectionId))
        },
        _onSelect: function(t) {
            var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
            e && "function" == typeof e.onSelect && e.onSelect(t), $("body").hasClass("panel-open") && (StyleHatch.closePanelMenu(), $("html, body").addClass("scroll-lock"), setTimeout(function() {
                $("html, body").removeClass("scroll-lock"), $("html, body").animate({
                    scrollTop: e.$container.offset().top
                }, 600)
            }, 400))
        },
        _onDeselect: function(t) {
            var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
            e && "function" == typeof e.onDeselect && e.onDeselect(t), $("body").hasClass("panel-open") && StyleHatch.closePanelMenu()
        },
        _onReorder: function(t) {
            var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
            e && "function" == typeof e.onReorder && e.onReorder(t)
        },
        _onBlockSelect: function(t) {
            var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
            e && "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
        },
        _onBlockDeselect: function(t) {
            var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
            e && "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
        },
        register: function(t, e) {
            this.constructors[t] = e, $("[data-section-type=" + t + "]").each(function(t, o) {
                this._createInstance(o, e)
            }.bind(this))
        }
    }), StyleHatch.cacheSelectors = function() {
        StyleHatch.cache = {
            $body: $("body"),
            $html: $("html"),
            $util: $("header.util"),
            $header: $("header.site-header"),
            $siteNav: $("header.site-header ul.site-nav"),
            $featuredCollection: $(".featured-collection"),
            $instagramCollection: $(".instagram-collection"),
            $addToCartForm: $("#AddToCartForm"),
            $addToCartButton: $("#AddToCart"),
            $cartButton: $("#CartButton"),
            $recoverPasswordLink: $("#RecoverPassword"),
            $hideRecoverPasswordLink: $("#HideRecoverPasswordLink"),
            $recoverPasswordForm: $("#RecoverPasswordForm"),
            $customerLoginForm: $("#CustomerLoginForm"),
            $passwordResetSuccess: $("#ResetSuccess")
        }
    }, StyleHatch.init = function() {
        document.documentElement.setAttribute("data-useragent", navigator.userAgent), StyleHatch.cacheSelectors(), StyleHatch.largeMobile = 700;
        var t = new StyleHatch.Sections;
        t.register("promos-section", StyleHatch.PromosSection), t.register("header-section", StyleHatch.HeaderSection), t.register("footer-section", StyleHatch.FooterSection), t.register("slideshow-section", StyleHatch.SlideshowSection), t.register("hero-video-section", StyleHatch.HeroVideoSection), t.register("featured-collection-section", StyleHatch.FeaturedCollectionSection), t.register("simple-collection-section", StyleHatch.SimpleCollectionSection), t.register("featured-text-section", StyleHatch.PageSection), t.register("custom-content-section", StyleHatch.PageSection), t.register("instagram-section", StyleHatch.InstagramSection), t.register("featured-blog-section", StyleHatch.GenericSection), t.register("product-template", StyleHatch.Product), t.register("collection-template", StyleHatch.Collection), t.register("collection-list-template", StyleHatch.Collection), t.register("list-collections-template", StyleHatch.ListCollections), t.register("blog-template", StyleHatch.BlogArticle), t.register("article-template", StyleHatch.BlogArticle), t.register("password-template", StyleHatch.Password), t.register("cart-template", StyleHatch.Cart), StyleHatch.currencyConverter && StyleHatch.CurrencyConverter.init(), StyleHatch.loginForms(), StyleHatch.videoLayout(), StyleHatch.initTemplates()
    }, StyleHatch.PromosSection = function() {
        return function(t) {
            (this.$container = $(t)).attr("data-section-id"), StyleHatch.Promos.init()
        }
    }(), StyleHatch.PromosSection.prototype = $.extend({}, StyleHatch.PromosSection.prototype, {
        onUnload: function() {
            StyleHatch.Promos.unload()
        },
        onBlockSelect: function(t) {
            StyleHatch.Promos.blockSelect(t)
        },
        onBlockDeselect: function(t) {
            StyleHatch.Promos.blockDeselect(t)
        }
    }), StyleHatch.Promos = function() {
        var t = {
                body: "body",
                page: "#page",
                promos: "#shopify-section-promos",
                promoBar: "header.promo-bar",
                bottomContainer: ".promo-bar-container.bottom",
                popup: ".promo-popup"
            },
            e = {};
        e = {
            scrollLock: !1,
            fixToZIndex: 992,
            hideTimers: [],
            slideSpeed: 400
        };
        var o = {};

        function a() {
            o.$promos.data("fixtoInstance") && o.$promos.fixTo("destroy")
        }
        return $.fn.extend({
            showPopup: function(t) {
                var e = $(this),
                    a = !0,
                    n = (e.data("show-delay"), e.data("show-again-delay")),
                    i = e.data("homepage-limit"),
                    r = e.data("visitor-limit"),
                    c = e.data("visitor"),
                    s = (e.data("show-for"), e.data("type"));
                1 == r && 0 == c && (a = !1);
                var d = "popup-" + e.data("id");
                $.cookie(d) && (a = !1), i && !o.$body.hasClass("template-index") && (a = !1), window.self !== window.top && "popup" == s && (a = !1), t && (a = !0);
                var l = e.find(".errors"),
                    u = getQueryString("contact%5Btags%5D");
                (l.length && u.includes("popup") && (a = !0, e.find("input#email").addClass("errors")), l.length && u.includes("signup-bar") && (a = !0), Modernizr.touchevents && e.find("form").removeAttr("target"), a) && ("popup" == s && $.magnificPopup.open({
                    items: {
                        src: e,
                        type: "inline",
                        showCloseBtn: !1
                    },
                    mainClass: "mfp-slideup",
                    removalDelay: 300,
                    callbacks: {
                        close: function() {
                            $.cookie(d, "shown", {
                                expires: n,
                                path: "/"
                            })
                        }
                    }
                }), "signup-bar" == s && (t ? e.addClass("visible force") : e.addClass("visible")), e.find(".icon-text").on("click", function(t) {
                    e.hidePopup(), t.preventDefault()
                }), e.find("form").on("submit", function(t) {
                    if (!t.target.checkValidity()) return !1;
                    e.hidePopup(), $(this).submit()
                }))
            },
            hidePopup: function() {
                $("#shopify-section-promos");
                var t = $(this),
                    e = t.data("type"),
                    o = t.data("id");
                if ("popup" == e && $.magnificPopup.close(), "signup-bar" == e) {
                    var a = "popup-" + o;
                    $.cookie(a, "shown", {
                        expires: 60,
                        path: "/"
                    }), $(".promo-bar.signup-bar").each(function(t) {
                        $(this).slideUp({
                            duration: 400,
                            progress: function() {
                                StyleHatch.refreshFixTo()
                            },
                            complete: function() {
                                StyleHatch.refreshFixTo(), $(this).removeClass("visible force")
                            }
                        })
                    })
                }
            },
            promoSlideUp: function() {
                $(this).slideUp({
                    duration: e.slideSpeed,
                    progress: StyleHatch.refreshFixTo,
                    complete: StyleHatch.refreshFixTo
                })
            },
            promoSlideDown: function() {
                $(this).slideDown({
                    duration: e.slideSpeed,
                    progress: StyleHatch.refreshFixTo,
                    complete: StyleHatch.refreshFixTo
                })
            },
            showMockPopup: function() {
                var t = $("#shopify-section-promos");
                $(".mock-popup-container").length || t.find(">*:first").append('<div class="mock-popup-container"></div>');
                var e = $(".mock-popup-container"),
                    o = $(this);
                o.appendTo(e), e.show(), o.show()
            },
            hideMockPopup: function() {
                var t = $(".mock-popup-container"),
                    e = $(this);
                t.hide(), e.hide()
            }
        }), {
            init: function() {
                o = {
                    $body: $(t.body),
                    $promos: $(t.promos),
                    $promosContainer: $(t.promos).find(">*:first"),
                    $promoBar: $(t.promoBar),
                    $bottomContainer: $(t.bottomContainer),
                    $popup: $(t.popup)
                }, e.scrollLock = o.$promos.find(">*:first").data("scroll-lock"), o.$promoBar.length && (o.$promoBar.each(function() {
                    var a = $(this),
                        n = a.data("hide-delay"),
                        i = a.data("bar-placement"),
                        r = a.find("div.errors");
                    r.length && r.prependTo(a), "bottom" == i && (o.$bottomContainer.length || (o.$promosContainer.append('<div class="promo-bar-container bottom"></div>'), o.$bottomContainer = $(t.bottomContainer)), a.appendTo(o.$bottomContainer), o.$bottomContainer.resize(function() {
                        var t = $(this).height() + "px";
                        o.$body.css({
                            "margin-bottom": t
                        })
                    })), a.hasClass("signup-bar") && a.showPopup(), "no-delay" !== n && e.hideTimers.push(setTimeout(function() {
                        a.data("pause-hide") || a.promoSlideUp()
                    }, n))
                }), a(), e.scrollLock && o.$promos.fixTo(t.page, {
                    zIndex: e.fixToZIndex
                })), o.$popup.length && o.$popup.each(function() {
                    var t = $(this),
                        e = t.data("show-delay"),
                        o = (t.data("homepage-limit"), t.data("visitor-limit"), t.data("visitor"), t.data("show-for")),
                        a = t.find(".errors");
                    a.length && (e = 0), setTimeout(function() {
                        var e = $(window).width();
                        switch (o) {
                            case "mobile":
                                e <= StyleHatch.largeMobile && t.showPopup();
                                break;
                            case "desktop":
                                e > StyleHatch.largeMobile && t.showPopup();
                                break;
                            case "both":
                                t.showPopup()
                        }
                    }, e)
                }), StyleHatch.Header.rebuildFixTo()
            },
            unload: function() {
                if (void 0 !== e.hideTimers && e.hideTimers instanceof Array) {
                    for (var t = 0; t < e.hideTimers.length; t++) clearTimeout(e.hideTimers[t]);
                    e.hideTimers.length = 0
                } else e.hideTimers = [];
                a(), StyleHatch.refreshFixTo(), o.$bottomContainer.remove(), $.magnificPopup.close()
            },
            blockSelect: function(t) {
                var e = $("#block-" + t.detail.blockId),
                    o = e.data("type");
                switch ($.magnificPopup.close(), o) {
                    case "announcement-bar":
                        e.promoSlideDown(), e.attr("data-pause-hide", !0);
                        break;
                    case "popup":
                        e.showMockPopup();
                        break;
                    case "signup-bar":
                        e.showPopup(!0)
                }
                StyleHatch.Header.rebuildFixTo(), StyleHatch.refreshFixTo()
            },
            blockDeselect: function(t) {
                var o = $("#block-" + t.detail.blockId),
                    a = o.data("type"),
                    n = o.data("show-for"),
                    i = $(window).width();
                switch (a) {
                    case "announcement-bar":
                        var r = o;
                        r.attr("data-pause-hide", !1);
                        var c = r.data("hide-delay");
                        r.data("bar-placement"), "desktop" == n && i <= StyleHatch.largeMobile ? o.promoSlideUp() : "mobile" == n && i > StyleHatch.largeMobile && o.promoSlideUp(), "no-delay" !== c && e.hideTimers.push(setTimeout(function() {
                            r.data("pause-hide") || r.promoSlideUp()
                        }, c));
                        break;
                    case "popup":
                        o.hideMockPopup();
                        break;
                    case "signup-bar":
                        "desktop" == n && i <= StyleHatch.largeMobile && (o.hidePopup(), StyleHatch.refreshFixTo()), "mobile" == n && i > StyleHatch.largeMobile && (o.hidePopup(), StyleHatch.refreshFixTo())
                }
                StyleHatch.Header.rebuildFixTo()
            },
            refreshFixTo: function() {
                o.$promos.data("fixtoInstance") && o.$promos.fixTo("refresh")
            }
        }
    }(), StyleHatch.HeaderSection = function() {
        return function(t) {
            (this.$container = $(t)).attr("data-section-id"), StyleHatch.Header.init()
        }
    }(), StyleHatch.HeaderSection.prototype = $.extend({}, StyleHatch.HeaderSection.prototype, {
        onUnload: function() {
            StyleHatch.Header.unload()
        }
    }), StyleHatch.Header = function() {
        var t = {
                htmlBody: "html, body",
                body: "body",
                page: "#page",
                section: "#shopify-section-header",
                promosSection: "#shopify-section-promos",
                util: "header.util",
                header: "header.site-header",
                siteNav: "header.site-header ul.site-nav",
                menuLink: ".menu-link",
                menuPanel: "#menu.panel",
                menuOverlay: ".mobile-menu-overlay"
            },
            e = {};
        e = {
            blurTimer: {},
            blurTime: 2e3,
            slideSpeed: 300,
            dropdownActiveClass: "dropdown-hover",
            subDropdownActiveClass: "sub-dropdown-hover"
        };
        var o = {};

        function a() {
            o = {
                $htmlBody: $(t.htmlBody),
                $body: $(t.body),
                $page: $(t.page),
                $section: $(t.section),
                $promosSection: $(t.promosSection),
                $util: $(t.util),
                $header: $(t.header),
                $siteNav: $(t.siteNav),
                $dropdownParent: $(t.siteNav).find("li.has-dropdown"),
                $defaultLink: $(t.siteNav).find("> li:not(.has-dropdown)"),
                $subMenuLinks: $(t.siteNav).find("li.has-dropdown a"),
                $subDropdownParent: $(t.siteNav).find("li.has-sub-dropdown"),
                $search: $(t.util).find(".search-wrapper"),
                $searchLink: $(t.util).find("a.search"),
                $searchClose: $(t.util).find("form.search-bar button"),
                $searchInput: $(t.util).find("form.search-bar input"),
                $menuLink: $(t.menuLink),
                $menuPanel: $(t.menuPanel),
                $menuPanelDropdown: $(t.menuPanel).find("li.has-dropdown > .show-dropdown"),
                $menuPanelSubDropdown: $(t.menuPanel).find("li.has-sub-dropdown > .show-dropdown")
            }
        }

        function n() {
            o.$search.slideDown({
                duration: e.slideSpeed,
                progress: function() {
                    StyleHatch.refreshFixTo()
                },
                complete: function() {
                    StyleHatch.refreshFixTo()
                }
            }), o.$searchInput.focus()
        }

        function i() {
            o.$searchInput.blur(), clearTimeout(e.blurTimer), o.$search.slideUp({
                duration: e.slideSpeed,
                progress: function() {
                    StyleHatch.refreshFixTo()
                },
                complete: function() {
                    StyleHatch.refreshFixTo()
                }
            })
        }

        function r() {
            o.$body.hasClass("panel-open") ? s() : c()
        }

        function c() {
            o.$htmlBody.addClass("panel-open"), window.scrollTo(0, 0)
        }

        function s() {
            o.$htmlBody.removeClass("panel-open")
        }

        function d(t) {
            t.removeClass(e.dropdownActiveClass), o.$body.off("touchstart"), t.find(".dropdown").attr("aria-hidden", "true"), t.find(".dropdown a").attr("tabindex", "-1")
        }

        function l(t) {
            t.removeClass(e.subDropdownActiveClass), t.removeClass("alternate-align"), t.find(".sub-dropdown").attr("aria-hidden", "true"), t.find(".sub-dropdown a").attr("tabindex", "-1")
        }

        function u() {
            var t = $("header.util, #shopify-section-header").filter(function() {
                return $(this).data("fixtoInstance")
            });
            t.length && t.fixTo("destroy")
        }

        function h() {
            a(), u(),
                function() {
                    var t = o.$section,
                        e = o.$promosSection,
                        a = o.$header,
                        n = o.$util,
                        i = a.data("scroll-lock");
                    if ("util" == i || "header" == i) {
                        var r = "";
                        e.data("fixtoInstance") && (r = "#shopify-section-promos"), n.fixTo("#page", {
                            zIndex: 991,
                            mind: r
                        })
                    }
                    "header" == i && (r = "header.util", e.data("fixtoInstance") && (r = "header.util, #shopify-section-promos"), t.fixTo("#page", {
                        zIndex: 990,
                        mind: r
                    }), t.resize(function() {
                        $(this).width() <= 700 ? t.fixTo("stop") : t.fixTo("start")
                    }))
                }()
        }
        return {
            init: function() {
                a(), $(t.menuOverlay).length || (o.$section.append('<div class="mobile-menu-overlay"></div>'), o.$menuOverlay = $(t.menuOverlay)), o.$searchLink.on("click.search", function(t) {
                    n(), t.preventDefault()
                }), o.$searchClose.on("click.search", function(t) {
                    i(), t.preventDefault()
                }), o.$searchInput.on("blur.search", function(t) {
                    e.blurTimer = setTimeout(i, e.blurTime), t.preventDefault()
                }), o.$menuLink.on("click.panel", function(t) {
                    r(), t.preventDefault()
                }), o.$menuOverlay.on("click.panel", function(t) {
                    r(), t.preventDefault()
                }), o.$menuPanelDropdown.on("click.panelDropdown", function(t) {
                    o.$menuPanelDropdown.parent().find("ul.dropdown").slideUp(), o.$menuPanelDropdown.parent().removeClass("expanded"), $(this).parent().find("ul.dropdown").is(":visible") || ($(this).parent().find("ul.dropdown").slideDown(), $(this).parent().addClass("expanded"))
                }), o.$menuPanelDropdown.find("> a").on("click.panelDropdown", function(t) {
                    t.preventDefault()
                }), o.$menuPanelDropdown.find("ul.dropdown li:not(.has-sub-dropdown) a").on("click.panelDropdown", function(t) {
                    t.stopPropagation()
                }), o.$menuPanelSubDropdown.on("click.panelDropdown", function(t) {
                    t.stopPropagation(), o.$menuPanelSubDropdown.parent().find("ul.sub-dropdown").slideUp(), o.$menuPanelSubDropdown.parent().removeClass("expanded"), $(this).parent().find("ul.sub-dropdown").is(":visible") || ($(this).parent().find("ul.sub-dropdown").slideDown(), $(this).parent().addClass("expanded"))
                }), o.$menuPanelSubDropdown.find("> a").on("click.panelDropdown", function(t) {
                    t.preventDefault()
                }), o.$menuPanelSubDropdown.find("ul.sub-dropdown a").on("click.panelDropdown", function(t) {
                    t.stopPropagation()
                }), o.$promosSection.resize(StyleHatch.refreshFixTo), o.$subMenuLinks.each(function() {
                    var t = $(this),
                        e = t.text(),
                        o = wordWrapper(e, 24, "<br/>\n");
                    t.html(o)
                }), d(o.$dropdownParent), o.$dropdownParent.on("mouseenter.dropdown touchstart.dropdown focusin.dropdown", function(t) {
                    var a = $(this);
                    a.hasClass(e.dropdownActiveClass) || t.preventDefault(), a.hasClass(e.dropdownActiveClass) || function(t) {
                        d($("." + e.dropdownActiveClass)), t.addClass(e.dropdownActiveClass), t.find(".dropdown").attr("aria-hidden", "false"), t.find(".dropdown a").attr("tabindex", "0");
                        var a = t.find("ul.dropdown");
                        a.css({
                            left: "auto"
                        });
                        var n = a.offset().left + a.outerWidth(),
                            i = $(window).width() - 20,
                            r = o.$header.width(),
                            c = o.$header.find(".logo-nav-contain").offset().left;
                        if (r + 40 > $(window).width() && (r = $(window).width(), c = -20), n > (i = r + c + 1)) {
                            var s = "-" + (n - i) + "px";
                            a.css({
                                left: s
                            })
                        }
                        setTimeout(function() {
                            o.$body.on("touchstart", function() {
                                d(t)
                            })
                        }, 250)
                    }(a)
                }), o.$dropdownParent.on("mouseleave.dropdown", function() {
                    d($(this))
                }), o.$subMenuLinks.on("touchstart.dropdown", function(t) {
                    t.stopImmediatePropagation()
                }), o.$subDropdownParent.on("mouseenter.subdropdown touchstart.subdropdown focusin.subdropdown", function(t) {
                    var o = $(this);
                    o.hasClass(e.subDropdownActiveClass) || t.preventDefault(), o.hasClass(e.subDropdownActiveClass) || function(t) {
                        d($("." + e.subDropdownActiveClass)), t.addClass(e.subDropdownActiveClass), t.find(".sub-dropdown").attr("aria-hidden", "false"), t.find(".sub-dropdown a").attr("tabindex", "0");
                        var o = t.find(".sub-dropdown").offset().left + t.find(".sub-dropdown").width(),
                            a = $(window).width();
                        o > a ? t.addClass("alternate-align") : t.removeClass("alternate-align")
                    }(o)
                }), o.$subDropdownParent.on("mouseleave.subdropdown", function() {
                    l($(this))
                }), o.$subDropdownParent.on("touchstart.subdropdown", function(t) {
                    t.stopImmediatePropagation()
                }), $("html").hasClass("touchevents") && o.$subDropdownParent.children("a").on("click", function(t) {
                    t.stopImmediatePropagation(), t.preventDefault()
                }), o.$subMenuLinks.on("focusout.dropdown", function(t) {
                    null == t.relatedTarget ? d($("." + e.dropdownActiveClass)) : ($(t.target).closest("li.has-dropdown")[0] !== $(t.relatedTarget).closest("li.has-dropdown")[0] && d($("." + e.dropdownActiveClass)), $(t.target).closest("li.has-sub-dropdown")[0] !== $(t.relatedTarget).closest("li.has-sub-dropdown")[0] && l($("." + e.subDropdownActiveClass)))
                }), h()
            },
            unload: function() {
                s(), clearTimeout(e.blurTimer), o.$searchLink.off("click.search"), o.$searchClose.off("click.search"), o.$searchInput.off("blur.search"), o.$menuLink.off("click.panel"), o.$menuPanelDropdown.off("click.panelDropdown"), o.$menuPanelDropdown.find("> a").off("click.panelDropdown"), o.$menuPanelDropdown.find("ul.dropdown li:not(.has-sub-dropdown) a").off("click.panelDropdown"), o.$menuPanelSubDropdown.off("click.panelDropdown"), o.$menuPanelSubDropdown.find("> a").off("click.panelDropdown"), o.$menuPanelSubDropdown.find("ul.sub-dropdown a").off("click.panelDropdown"), o.$promosSection.removeResize(StyleHatch.refreshFixTo), o.$dropdownParent.off("mouseenter.dropdown touchstart.dropdown focusin.dropdown"), o.$dropdownParent.off("mouseleave.dropdown"), o.$subMenuLinks.off("touchstart.dropdown"), o.$subDropdownParent.off("mouseenter.subdropdown touchstart.subdropdown focusin.subdropdown"), o.$subDropdownParent.off("mouseleave.subdropdown"), o.$subDropdownParent.off("touchstart.subdropdown"), o.$subMenuLinks.off("focusout.dropdown"), u()
            },
            openSearch: n,
            closeSearch: i,
            togglePanelMenu: r,
            openPanelMenu: c,
            closePanelMenu: s,
            rebuildFixTo: h
        }
    }(), StyleHatch.FooterSection = function() {
        return function(t) {
            (this.$container = $(t)).attr("data-section-id")
        }
    }(), StyleHatch.SlideshowSection = function() {
        return function(t) {
            var e = this.$container = $(t);
            e.attr("data-section-id"), StyleHatch.Slideshow.init(e)
        }
    }(), StyleHatch.SlideshowSection.prototype = $.extend({}, StyleHatch.SlideshowSection.prototype, {
        onUnload: function(t) {
            StyleHatch.Slideshow.unload(t)
        },
        onBlockSelect: function(t) {
            StyleHatch.Slideshow.blockSelect(t)
        },
        onBlockDeselect: function(t) {
            StyleHatch.Slideshow.blockDeselect(t)
        }
    }), StyleHatch.Slideshow = function() {
        return {
            init: function(t) {
                var e = t.find(".slideshow-carousel"),
                    o = e.find(".slide__item");
                $(window).on("resize", function() {
                    o.each(function(t) {
                        var e;
                        $(window).width() > 700 ? e = $(this).find("img.slide__image-desktop") : (e = $(this).find("img.slide__image-mobile")).length < 1 && (e = $(this).find("img.slide__image-desktop")), e.hasClass("lazymanual") && (e.attr("src", e.attr("data-preload")).removeAttr("data-preload"), e.removeClass("lazymanual").addClass("lazyload"))
                    })
                }), $(window).trigger("resize");
                var a = e.data("flickity-options");
                e.flickity(a), t.find(".slide__item-video").each(function() {
                    var t = $(this).find(".slide__item-image"),
                        e = $(this).data("video-id");
                    t.YTPlayer({
                        fitToBackground: !0,
                        videoId: e,
                        repeat: !0,
                        mute: !0,
                        playerVars: {
                            rel: 0
                        },
                        callback: function() {
                            $(window).trigger("resize")
                        }
                    })
                })
            },
            unload: function(t) {
                var e = $(".slideshow-" + t.detail.sectionId);
                e.find(".slideshow-carousel").flickity("destroy");
                var o = e.find(".slide__item-video .slide__item-image");
                o.removeData("yt-init").removeData("ytPlayer").removeClass("loaded"), $(window).off("resize.YTplayer" + o.ID), $(window).off("scroll.YTplayer" + o.ID), o.$body = null, o.$node = null, o.$YTPlayerString = null, o.player = null
            },
            blockSelect: function(t) {
                var e = $("#block-" + t.detail.blockId),
                    o = e.closest(".slideshow-carousel"),
                    a = e.data("slide-index");
                o.flickity("pausePlayer"), o.flickity("select", a, !0, !0), o.find("img").removeClass(".lazymanual").addClass("lazyload")
            },
            blockDeselect: function(t) {
                $("#block-" + t.detail.blockId).closest(".slideshow-carousel").flickity("unpausePlayer")
            }
        }
    }(), StyleHatch.HeroVideoSection = function() {
        return function(t) {
            var e = this.$container = $(t);
            e.attr("data-section-id"), StyleHatch.HeroVideo.init(e)
        }
    }(), StyleHatch.HeroVideoSection.prototype = $.extend({}, StyleHatch.HeroVideoSection.prototype, {
        onUnload: function(t) {
            StyleHatch.HeroVideo.unload(t)
        }
    }), StyleHatch.HeroVideo = function() {
        return {
            init: function(t) {
                var e = t.find(".wrapper"),
                    o = t.data("video-id");
                e.removeData("ytPlayer"), e.YTPlayer({
                    fitToBackground: !0,
                    videoId: o,
                    repeat: !0,
                    mute: !0,
                    playerVars: {
                        rel: 0
                    }
                })
            },
            unload: function(t) {
                var e = $(".slideshow-" + t.detail.sectionId).find(".wrapper");
                e.removeData("yt-init").removeData("ytPlayer").removeClass("loaded"), e.find(".ytplayer-container .ytplayer-shield").remove()
            }
        }
    }(), StyleHatch.PageSection = function() {
        return function(t) {
            var e = this.$container = $(t);
            e.attr("data-section-id"), StyleHatch.Page.init(e)
        }
    }(), StyleHatch.Page = function() {
        return {
            init: function(t) {
                t.fitVids()
            },
            unload: function(t) {}
        }
    }(), StyleHatch.FeaturedCollectionSection = function() {
        return function(t) {
            var e = this.$container = $(t);
            e.attr("data-section-id"), e.find(".box .image-table").matchHeight(), $.fn.matchHeight._throttle = 100, e.imagesLoaded(function() {
                $.fn.matchHeight._update()
            }), e.productBox(), StyleHatch.currencyConverter && StyleHatch.CurrencyConverter.init()
        }
    }(), StyleHatch.FeaturedCollectionSection.prototype = $.extend({}, StyleHatch.FeaturedCollectionSection.prototype, {
        onUnload: function(t) {
            var e = $("#section-" + t.detail.sectionId);
            e.attr("data-section-id");
            e.find(".box .image-table").matchHeight({
                remove: !0
            }), e.destroyProductBox()
        }
    }), StyleHatch.SimpleCollectionSection = function() {
        return function(t) {
            var e = this.$container = $(t);
            e.attr("data-section-id"), e.find(".box .image-table").matchHeight(), $.fn.matchHeight._throttle = 100, e.imagesLoaded(function() {
                $.fn.matchHeight._update()
            }), e.productBox(), StyleHatch.currencyConverter && StyleHatch.CurrencyConverter.init()
        }
    }(), StyleHatch.SimpleCollectionSection.prototype = $.extend({}, StyleHatch.SimpleCollectionSection.prototype, {
        onUnload: function(t) {
            var e = $("#section-" + t.detail.sectionId);
            e.attr("data-section-id");
            e.find(".box .image-table").matchHeight({
                remove: !0
            }), e.destroyProductBox()
        }
    }), StyleHatch.instagrams = {}, StyleHatch.InstagramSection = function() {
        return function(t) {
            var e = this.$container = $(t),
                o = e.attr("data-section-id"),
                a = this.instagram = "#Instagram-" + o;
            if ($("html").hasClass("lt-ie9")) return !1;
            var n = e.find(".instagram-container"),
                i = e.find("header a.button, footer a.button"),
                r = e.data("image-count"),
                c = e.data("instagram-access-token"),
                s = "https://api.instagram.com/v1/users/self/media/recent/?access_token=" + c + "&count=20",
                d = StyleHatch.Strings.instagramAddToken,
                l = StyleHatch.Strings.instagramInvalidToken,
                u = StyleHatch.Strings.instagramRateLimitToken,
                h = function(t) {
                    if (t.data) {
                        if (t.data.length < r) {
                            var o = t.data.length,
                                a = r - (r - o);
                            r = t.data.length, e.find(".box").each(function(t) {
                                t >= a && $(this).hide()
                            })
                        }
                        for (var c = 0; c < r; c++) {
                            var s = t.data[c].images.thumbnail.url,
                                d = (t.data[c].images.low_resolution.url, s.replace("s150x150", "s480x480"), t.data[c].images.standard_resolution.url),
                                l = t.data[c].link,
                                u = t.data[c].likes.count,
                                h = t.data[c].comments.count,
                                p = "";
                            t.data[c].caption && (p = t.data[c].caption.text);
                            var f = e.find(".box-" + c),
                                m = f.find("figure > a"),
                                y = f.find("figure > a, li > a"),
                                g = f.find("figcaption > p"),
                                v = f.find("a.likes span.label"),
                                S = f.find("a.comments span.label");
                            m.html('<div class="card__image-bg"></div>');
                            var b = m.find(".card__image-bg");
                            b.css("background-image", "url(" + d + ")"), b.attr("alt", $("<div/>").html(p).text()), y.attr("href", l), g.html(p), v.text(u), S.text(h)
                        }
                        var w = "https://www.instagram.com/" + t.data[0].user.username;
                        i.attr("href", w), i.attr("target", "_blank"), e.show(), n.addClass("loaded")
                    }
                };
            if (storeWithExpiration.get(c)) {
                var p = storeWithExpiration.get(c);
                h(p)
            } else c ? $.ajax({
                url: s,
                dataType: "jsonp",
                timeout: 5e3,
                success: function(t) {
                    switch (t.meta.code) {
                        case 400:
                            n.attr("data-helper-text", l), storeWithExpiration.set(c, t, 432e5), e.show();
                            break;
                        case 429:
                            n.attr("data-helper-text", u), e.show();
                            break;
                        default:
                            h(t), storeWithExpiration.set(c, t, 432e5)
                    }
                }
            }) : (n.attr("data-helper-text", d), e.show());
            StyleHatch.instagrams[a] = this
        }
    }(), StyleHatch.InstagramSection.prototype = $.extend({}, StyleHatch.InstagramSection.prototype, {
        onUnload: function() {
            delete StyleHatch.instagrams[this.instagram]
        }
    }), StyleHatch.GenericSection = function() {
        return function(t) {
            (this.$container = $(t)).attr("data-section-id"), StyleHatch.cacheSelectors()
        }
    }(), StyleHatch.Product = function() {
        function t(t) {
            var e = this.$container = $(t),
                o = e.attr("data-section-id");
            if (this.settings = {
                    enableHistoryState: e.data("enable-history-state") || !1,
                    imageSize: "394x",
                    imageZoomSize: null,
                    namespace: ".slideshow-" + o,
                    sectionId: o,
                    zoomEnabled: !1,
                    lightboxEnabled: !1,
                    productImageLightboxData: []
                }, this.selectors = {
                    addToCart: "#AddToCart-" + o,
                    addToCartText: "#AddToCartText-" + o,
                    comparePrice: "#ComparePrice-" + o,
                    originalPrice: "#ProductPrice-" + o,
                    SKU: ".variant-sku",
                    originalSelectorId: "#ProductSelect-" + o,
                    productFeaturedImage: "#FeaturedImage-" + o,
                    productImageWrap: ".featured-container-" + o,
                    productPrices: ".product-single__price-" + o,
                    productThumbImages: ".product-single__thumbnail--" + o,
                    productThumbs: "#ProductThumbs-" + o,
                    quantityWrap: ".quantity-" + o,
                    quantity: ".quantity-select-" + o,
                    cartError: ".cart-error-" + o,
                    singleOptionSelector: ".single-option-selector-" + o
                }, $("#ProductJson-" + o).html()) {
                this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + o).innerHTML), this.settings.zoomEnabled = $(this.selectors.productImageWrap).hasClass("featured-zoom"), this.settings.lightboxEnabled = $(this.selectors.productImageWrap).data("lightbox"), StyleHatch.currencyConverter && StyleHatch.CurrencyConverter.init(), StyleHatch.ajaxCartEnable && StyleHatch.AjaxCart.init(), this._initVariants(), this._initQuanitySelect(), this._initImageSwitch();
                var a = this;
                setTimeout(function() {
                    theme.Images.preload(a.productSingleObject.images, a.settings.imageSize)
                }, 3e3)
            }
        }

        function e(t) {
            t.easyZoom()
        }

        function o(t) {
            t.easyZoom().data("easyZoom").teardown()
        }
        return t.prototype = $.extend({}, t.prototype, {
            _initVariants: function() {
                var t = {
                    $container: this.$container,
                    enableHistoryState: this.$container.data("enable-history-state") || !1,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    product: this.productSingleObject
                };
                this.variants = new slate.Variants(t), this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCart.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)), this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this))
            },
            _initQuanitySelect: function() {
                $(this.selectors.quantity).each(function() {
                    var t = $(this),
                        e = t.find(".adjust-minus"),
                        o = t.find(".adjust-plus"),
                        a = t.find("input.quantity"),
                        n = a.val();
                    a.on("keydown keyup blur focusout", function(t) {
                        n = Number(a.val());
                        var e = Number(a.attr("data-inventory"));
                        n > e && 46 !== t.keyCode && 8 !== t.keyCode ? (t.preventDefault(), a.val(e), $("[js-target=error]").addClass("active")) : $("[js-target=error]").removeClass("active")
                    }), e.on("click", function(t) {
                        (n = a.val()) > 1 && (n--, a.val(n), $("[js-target=error]").removeClass("active")), t.preventDefault()
                    }), o.on("click", function(t) {
                        n = Number(a.val());
                        var e = Number(a.attr("data-inventory"));
                        console.log("quantity: ", n), console.log("max: ", e), n < e ? (n++, a.val(n)) : ($("[js-target=error]").addClass("active"), setTimeout(function() {
                            $("[js-target=error]").removeClass("active")
                        }, 3e3)), t.preventDefault()
                    })
                })
            },
            _initImageSwitch: function() {
                if (!Modernizr.touchevents && this.settings.zoomEnabled && e($(this.selectors.productImageWrap)), this.settings.lightboxEnabled) {
                    var t = this.productSingleObject.images;
                    StyleHatch.productImageLightboxData = this.settings.productImageLightboxData, $(window).on("resize", function() {
                        var e = slate.utils.defaultTo(window.devicePixelRatio, 1),
                            o = $(window).width(),
                            a = Math.floor(e * o);
                        StyleHatch.productImageLightboxData = [];
                        for (var n = 0; n < t.length; n++) {
                            var i = t[n],
                                r = {
                                    src: theme.Images.getSizedImageUrl(i, a + "x")
                                };
                            StyleHatch.productImageLightboxData.push(r)
                        }
                        void 0 !== $("#ProductPhoto a").data().magnificPopup && ($("#ProductPhoto").find("a").data().magnificPopup.items = StyleHatch.productImageLightboxData)
                    }).trigger("resize");
                    var o = $(this.selectors.productImageWrap);
                    $(this.selectors.productImageWrap).find("a").magnificPopup({
                        type: "image",
                        mainClass: "mfp-with-zoom",
                        items: StyleHatch.productImageLightboxData,
                        gallery: {
                            enabled: !0
                        },
                        callbacks: {
                            beforeOpen: function(t) {
                                var e = parseInt(o.find("img").attr("data-position"));
                                this.goTo(e)
                            }
                        }
                    })
                }
                if ($(this.selectors.productThumbImages).length) {
                    var a = this;
                    $(this.selectors.productThumbImages).on("click", function(t) {
                        t.preventDefault();
                        var e = $(this);
                        e.find("img").data("img"), e.find("img").data("highres");
                        a._updateResponsiveImage(e)
                    })
                }
            },
            _updateResponsiveImage: function(t) {
                var a = t,
                    n = a.find("img"),
                    i = $("#ProductImage"),
                    r = i.closest(".card__image-container"),
                    c = i.closest(".featured-container"),
                    s = i.closest(".productimage-limit"),
                    d = $(document.createElement("img"));
                d.attr({
                    id: "ProductImage",
                    class: "lazyload",
                    src: n.data("default"),
                    alt: n.attr("alt"),
                    "data-src": n.data("src-pattern"),
                    "data-aspectratio": n.data("aspectratio"),
                    "data-position": n.data("position"),
                    "data-max-width": n.data("max-width"),
                    "data-widths": "[" + n.data("widths") + "]",
                    "data-id": i.data("id"),
                    "data-sizes": i.data("sizes")
                }), i.remove(), s.css({
                    "max-width": n.data("max-width") + "px"
                }), s.append(d), this.settings.zoomEnabled && o(c), r.attr("href", a.attr("href")), !Modernizr.touchevents && this.settings.zoomEnabled && (r.data("zoom", a.attr("href")), e(c));
                $(this.selectors.productThumbImages).removeClass("active"), a.addClass("active")
            },
            _updateAddToCart: function(t) {
                var e = t.variant;
                e ? ($(this.selectors.cartError).hide(), $(this.selectors.productPrices).removeClass("visibility-hidden").attr("aria-hidden", "true"), e.available ? ($(this.selectors.addToCart).removeClass("disabled").prop("disabled", !1), $(this.selectors.addToCartText).text(StyleHatch.Strings.addToCart), $(".add-to-cart").show(), $(this.selectors.quantityWrap).show(), $(".wmwproduct__nostock-container").removeClass("active")) : ($(this.selectors.addToCart).addClass("disabled").prop("disabled", !0), $(this.selectors.quantityWrap).hide(), $(".wmwproduct__nostock-container").addClass("active"))) : ($(this.selectors.addToCart).addClass("disabled").prop("disabled", !0), $(this.selectors.addToCartText).text(StyleHatch.Strings.soldOut), $(this.selectors.productPrices).addClass("visibility-hidden").attr("aria-hidden", "false"), $(this.selectors.quantityWrap).hide())
            },
            _updateImages: function(t) {
                var e = t.variant;
                theme.Images.getSizedImageUrl(e.featured_image.src, this.settings.imageSize);
                this.settings.zoomEnabled && theme.Images.getSizedImageUrl(e.featured_image.src, this.settings.imageZoomSize);
                var o = e.featured_image.position - 1,
                    a = $(this.selectors.productThumbImages).eq(o);
                this._updateResponsiveImage(a)
            },
            _updatePrice: function(t) {
                var e = t.variant;
                $(this.selectors.originalPrice).html(theme.Currency.formatMoney(e.price, StyleHatch.currencyFormat)), StyleHatch.currencyConverter && (removeDataAttributes($(this.selectors.originalPrice)), Currency.convertAll(StyleHatch.shopCurrency, $("[name=currencies]").val()), $(".selected-currency").text(Currency.currentCurrency)), e.compare_at_price > e.price ? ($(this.selectors.comparePrice).find("span.money").html(theme.Currency.formatMoney(e.compare_at_price, StyleHatch.currencyFormat)), $(this.selectors.comparePrice).show()) : $(this.selectors.comparePrice).hide()
            },
            _updateSKU: function(t) {
                var e = t.variant;
                $(this.selectors.SKU).html(e.sku)
            },
            onUnload: function() {
                this.$container.off(this.settings.namespace), $.magnificPopup.close(), this.settings.zoomEnabled && o($(this.selectors.productImageWrap)), StyleHatch.ajaxCartEnable && StyleHatch.AjaxCart.unload(), this.$container.destroyProductBox()
            }
        }), t
    }(), StyleHatch.Collection = function() {
        var t = "sort_by",
            e = "title-ascending",
            o = {
                sortSelection: "#SortBy",
                defaultSort: ".sort-by__default-sort",
                viewChange: ".change-view",
                advancedFilter: ".advanced-filter a",
                filterCollection: ".mobile-aside-container > a.button.simple",
                mobileAside: ".mobile-aside-container aside",
                productBox: ".box.product .image-table"
            };

        function a(t) {
            var e = this.$container = $(t);
            e.attr("data-section-id");
            this.$sortSelect = $(o.sortSelection, e), this.defaultSort = this._getDefaultSortValue(), this.$viewButton = $(o.viewChange), this.$sortSelect.on("change", this._onSortChange.bind(this)), this.$viewButton.on("click", this._onViewChange), this.$productbox = $(o.productBox, e), this._initMatchHeight(), this._initSidebar(), this._initAdvancedTags(), e.productBox(), StyleHatch.currencyConverter && StyleHatch.CurrencyConverter.init()
        }
        return a.prototype = $.extend({}, a.prototype, {
            _onSortChange: function(e) {
                var o = "";
                this.sort = this._getSortValue(), this.sort !== this.defaultSort && (o = [t + "=" + this.sort]);
                var a = document.URL;
                if (a.indexOf("?") > -1) document.location.href = replaceUrlParam(a, t, this.sort);
                else {
                    var n = document.location.search = o.length ? "?" + o : "";
                    document.location.href = this.$filterSelect.val() + n
                }
            },
            _getSortValue: function() {
                return this.$sortSelect.val() || this.defaultSort
            },
            _getDefaultSortValue: function() {
                return $(o.defaultSort, this.$container).val() || e
            },
            _onViewChange: function(t) {
                var e = $(this).data("view"),
                    o = document.URL,
                    a = o.indexOf("?") > -1;
                window.location = a ? replaceUrlParam(o, "view", e) : o + "?view=" + e, t.preventDefault()
            },
            _initSidebar: function() {
                $(o.filterCollection).on("click", function(t) {
                    $(o.mobileAside).slideToggle(), t.preventDefault()
                })
            },
            _initAdvancedTags: function() {
                var t, e, a, n;
                $(o.advancedFilter).on("click", function(o) {
                    t = $(this).parent(), e = t.data("group"), a = t.data("handle"), n = $('.active[data-group="' + e + '"]'), !t.hasClass("active") && n.size() && (o.preventDefault(), location.href = location.href.replace(n.data("handle"), a).replace(/(&page=\d+)|(page=\d+&)|(\?page=\d+$)/, ""))
                })
            },
            _initMatchHeight: function() {
                this.$productbox.matchHeight(), $.fn.matchHeight._throttle = 100, this.$container.imagesLoaded(function() {
                    $.fn.matchHeight._update()
                })
            },
            _destroyMatchHeight: function() {
                this.$productbox.matchHeight({
                    remove: !0
                })
            },
            onUnload: function() {
                this.$sortSelect.off("change"), this.$viewButton.off("click"), $(o.advancedFilter).off("click"), this._destroyMatchHeight(), this.$container.destroyProductBox()
            }
        }), a
    }(), StyleHatch.ListCollections = function() {
        var t = {
            productBox: ".box .image-table"
        };

        function e(e) {
            var o = this.$container = $(e),
                a = (o.attr("data-section-id"), o.data("layout")),
                n = o.find(".card__image");
            this.$productbox = $(t.productBox, o), this._initMatchHeight(), "preview" == a ? o.productBox() : n.onCardAttrChange(), StyleHatch.currencyConverter && StyleHatch.CurrencyConverter.init()
        }
        return e.prototype = $.extend({}, e.prototype, {
            _initMatchHeight: function() {
                this.$productbox.matchHeight(), $.fn.matchHeight._throttle = 100, this.$container.imagesLoaded(function() {
                    $.fn.matchHeight._update()
                })
            },
            _destroyMatchHeight: function() {
                this.$productbox.matchHeight({
                    remove: !0
                })
            },
            onUnload: function() {
                this._destroyMatchHeight(), $container.destroyProductBox()
            }
        }), e
    }(), StyleHatch.BlogArticle = function() {
        var t = ".mobile-aside-container > a.button.simple",
            e = ".mobile-aside-container aside";

        function o(t) {
            (this.$container = $(t)).attr("data-section-id");
            this._initSidebar(), StyleHatch.videoLayout()
        }
        return o.prototype = $.extend({}, o.prototype, {
            _initSidebar: function() {
                $(t).on("click", function(t) {
                    $(e).slideToggle(), t.preventDefault()
                })
            },
            onUnload: function() {
                $(t).off("click")
            }
        }), o
    }(), StyleHatch.Password = function() {
        function t(t) {
            (this.$container = $(t)).attr("data-section-id");
            var e = $("#login_form");
            $(".login-popup").magnificPopup({
                type: "inline",
                midClick: !0,
                mainClass: "mfp-fade",
                closeBtnInside: !1,
                callbacks: {
                    afterClose: function() {
                        $("a").blur(), e.find(".errors").remove()
                    }
                }
            }), $("#mc-embedded-subscribe-form").on("submit", function() {
                $("p.signup-message").hide(), $("p.thanks-message").show(), $(this).find(".input-row").hide()
            }), e.find(".errors").length > 0 && $(".login-popup").magnificPopup("open")
        }
        return t.prototype = $.extend({}, t.prototype, {
            onUnload: function() {
                $.magnificPopup.close(), $("#mc-embedded-subscribe-form").off("submit")
            }
        }), t
    }(), StyleHatch.Cart = function() {
        function t(t) {
            (this.$container = $(t)).attr("data-section-id");
            StyleHatch.quantitySelect()
        }
        return t.prototype = $.extend({}, t.prototype, {
            onUnload: function() {}
        }), t
    }(), StyleHatch.AjaxCart = function() {
        var t = {
                body: "body",
                util: "header.util",
                cartPreview: ".cart-preview",
                addToCartForm: "#AddToCartForm",
                addToCartButton: ".add-to-cart",
                cartButton: "#CartButton",
                cartCount: "#CartCount",
                cartCountMob: ".cartCount",
                cartCost: "#CartCost"
            },
            e = {
                addURL: "/cart/add.js",
                cartURL: "/cart.js",
                clearURL: "/cart/clear.js"
            },
            o = {};

        function a() {
            setTimeout(function() {
                o.$addToCartButton.removeClass("added").prop("disabled", !1).text(StyleHatch.Strings.addToCart)
            }, 1e3)
        }

        function n(t, e) {
            e.hasOwnProperty("backorder") && e.backorder ? $.magnificPopup.open({
                items: {
                    src: '<div class="popup-backorder"><p class="popup-backorder__message">' + popupBackorder__message + '</p><div class="popup-backorder__buttons"><button class="popup-backorder__cancel">Cancel</button><button class="popup-backorder__add-to-cart">Add to Cart</button></div></div>',
                    type: "inline",
                    showCloseBtn: !0
                },
                mainClass: "mfp-slideup",
                removalDelay: 300,
                callbacks: {
                    open: function(e) {
                        var o = $(".popup-backorder__cancel"),
                            a = $(".popup-backorder__add-to-cart");
                        o.on("click", function() {
                            $.magnificPopup.close()
                        }), a.on("click", function() {
                            $.magnificPopup.close(), i(t)
                        })
                    },
                    close: function() {}
                }
            }) : i(t)
        }

        function i(t) {
            return o.$addToCartButton.addClass("added").prop("disabled", !0).text("Added to Cart"), $.post(e.addURL, t.serialize(), function(t) {
                var n = t;
                $.get(e.cartURL, function(t) {
                    var e = t;
                    ! function(t) {
                        o.$cartButton;
                        var e = o.$cartCount,
                            a = o.$cartCountMob,
                            n = o.$cartCost,
                            i = t.item_count,
                            r = theme.Currency.formatMoney(t.total_price, StyleHatch.currencyFormat);
                        e.text(i), a.html(i), i > 0 ? $(".wmwnav__icons-cart").addClass("cart_full is-visible") : $(".wmwnav__icons-cart").removeClass("cart_full is-visible");
                        n.removeClass("money"), n.html('<span class="money">' + r + "</span>"), StyleHatch.currencyConverter && Currency.convertAll(StyleHatch.shopCurrency, jQuery("[name=currencies]").val())
                    }(e),
                    function(t, e) {
                        var a = o.$util,
                            n = o.$cartPreview;
                         clearTimeout(o.hideCartPreview), o.$cartPreview.hide();
                        var i = e.item_count,
                            // r = theme.Currency.formatMoney(e.total_price, StyleHatch.currencyFormat),
                            c = (t = JSON.parse(t)).product_title,
                            s = t.variant_options,
                            d = t.image,
                            l = t.url,
                            // u = theme.Currency.formatMoney(t.price, StyleHatch.currencyFormat),
                            h = (t.quantity, theme.Currency.formatMoney(t.line_price, StyleHatch.currencyFormat), n.find(".product-image").empty());
                            h.append('<img src="' + d + '" alt="' + c + '">'), h.attr("href", l);
                            
                            var newPrice = 0;
                            for(var x = 0; x < e.items.length; x++) {
                                if(e.items[x].properties != undefined && e.items[x].properties['club-price'] != null) {
                                    var parsedPropPrice = parseFloat(e.items[x].properties['club-price'] * e.items[x].quantity);
                                    var parsedLinePrice = parseFloat(e.items[x].line_price);
                                    if(parsedPropPrice > parsedLinePrice || e.items[x].properties['club-price'] == null) {
                                        newPrice += parsedLinePrice;
                                    }
                                    else {
                                        newPrice += parsedPropPrice;
                                    }
                                }
                                else {
                                    newPrice += parseFloat(e.items[x].line_price);
                                }
                            }
                            
                            var justAdded = 0;
                            if(t.properties != undefined && t.properties['club-price'] != null) {
                                var parsedFinalPrice = parseFloat(t.final_price);
                                var parsedPropertyPrice = parseFloat(t.properties['club-price']);

                                if(parsedPropertyPrice > parsedFinalPrice || t.properties['club-price'] == null) {
                                    justAdded = parsedFinalPrice;
                                }
                                else {
                                    justAdded = parsedPropertyPrice
                                }
                            }
                            else {
                                justAdded = parseFloat(t.final_price);
                            }


                        var r = theme.Currency.formatMoney(newPrice, StyleHatch.currencyFormat);
                        var u = theme.Currency.formatMoney(justAdded, StyleHatch.currencyFormat);

                        var p = n.find(".product-title");
                        p.html(c), p.attr("href", l);
                        var f = n.find(".product-variant").empty();
                        $.each(s, function() {
                            this.toLowerCase().indexOf("default title") < 0 ? (f.show(), f.append("<li>" + this + "</li>")) : f.hide()
                        });
                        var m = n.find(".product-price");
                        m.removeClass("money"), m.html('<span class="money">' + u + "</span>"), n.find(".item-count").text(i), i > 1 ? (n.find(".count.plural").show(), n.find(".count.singular").hide()) : (n.find(".count.plural").hide(), n.find(".count.singular").show());
                        n.find(".total-price").html('<span class="money">' + r + "</span>");
                        var y = a.height();
                        n.css({
                            top: y
                        }), n.fadeIn(300), o.hideCartPreview = setTimeout(function() {
                            n.fadeOut(300)
                        }, 6e3), n.find("a.continue-shopping").on("click", function(t) {
                            n.fadeOut(300), t.preventDefault()
                        }), StyleHatch.currencyConverter && Currency.convertAll(StyleHatch.shopCurrency, jQuery("[name=currencies]").val())
                    }(n, e), a()
                }, "json")
            }, "text").error(function() {
                a()
            }), !1
        }
        return {
            init: function() {
                (o = {
                    $body: $(t.body),
                    $util: $(t.util),
                    $cartPreview: $(t.cartPreview),
                    $addToCartForm: $(t.addToCartForm),
                    $addToCartButton: $(t.addToCartButton),
                    $cartButton: $(t.cartButton),
                    $cartCount: $(t.cartCount),
                    $cartCountMob: $(t.cartCountMob),
                    $cartCost: $(t.cartCost)
                }).$addToCartForm.on("submit", function(t) {
                    var e = $(this);
                    ! function(t) {
                        var t = t,
                            e = $("[js-target=quantity]"),
                            o = Number(e.val()),
                            i = e.attr("data-inventory"),
                            r = "true" === e.attr("data-backorder"),
                            c = (c = $("[js-sku]:first").text()).trim();
                        $.ajax({
                            type: "GET",
                            url: "/cart.js",
                            dataType: "json",
                            success: function(e) {
                                for (var s = !1, d = !1, l = !1, u = 0; u < e.items.length && 1 != l; u++) {
                                    var h = Number(e.items[u].quantity),
                                        p = o + h;
                                    e.items[u].sku == c && p <= i ? (s = !0, d = !0, l = !0, console.log("In cart, add to cart")) : e.items[u].sku == c && p > i ? (s = !1, d = !0, l = !0, console.log("In cart, don't add to cart")) : (s = !0, d = !1, console.log("Not in cart, add to cart"))
                                }
                                console.log("inCartAlready: ", d), console.log("canAdd: ", s);
                                var f = {
                                    backorder: r
                                };
                                d ? s ? n(t, f) : ($("[js-target=error]").addClass("active"), setTimeout(function() {
                                    $("[js-target=error]").removeClass("active")
                                }, 3e3), a()) : (n(t, f), console.log("Not in cart, add to cart"))
                            },
                            error: function() {}
                        })
                    }(e), t.preventDefault(), console.log("yes it is!")
                })
            },
            clearCart: function() {
                $.post(e.clearURL)
            },
            unload: function() {
                o.$addToCartForm.off("submit")/*, clearTimeout(o.hideCartPreview), o.$cartPreview.hide()*/
            }
        }
    }(), StyleHatch.CurrencyConverter = function() {
        var t = {
                body: "body",
                money: "span.money"
            },
            e = {
                enabled: !1
            },
            o = {};

        function a() {
            e.cookieCurrency = Currency.cookie.read(), $("span.money span.money").each(function() {
                $(this).parents(t.money).removeClass("money")
            }), o.$money.each(function() {
                "" !== Currency.currentCurrency ? $(this).attr("data-currency-" + Currency.currentCurrency, $(this).html()) : $(this).attr("data-currency-" + StyleHatch.shopCurrency, $(this).html())
            }), null == e.cookieCurrency ? StyleHatch.shopCurrency !== StyleHatch.defaultCurrency ? Currency.convertAll(StyleHatch.shopCurrency, StyleHatch.defaultCurrency) : Currency.currentCurrency = StyleHatch.defaultCurrency : $("[name=currencies]").size() && 0 === $("[name=currencies] option[value=" + e.cookieCurrency + "]").size() ? (Currency.currentCurrency = StyleHatch.shopCurrency, Currency.cookie.write(StyleHatch.shopCurrency)) : e.cookieCurrency === StyleHatch.shopCurrency ? Currency.currentCurrency = StyleHatch.shopCurrency : Currency.convertAll(StyleHatch.shopCurrency, e.cookieCurrency), $("[name=currencies]").val(Currency.currentCurrency).change(function() {
                var t = $(this).val();
                Currency.convertAll(Currency.currentCurrency, t), $(".selected-currency").text(Currency.currentCurrency), $("p.currency-at-checkout").length > 0 && (Currency.currentCurrency == StyleHatch.shopCurrency ? $("p.currency-at-checkout").hide() : $("p.currency-at-checkout").show())
            }), $("[name=currencies]").val(Currency.currentCurrency).change()
        }
        return {
            init: function() {
                o = {
                    $body: $(t.body),
                    $money: $(t.money)
                }, a()
            },
            config: e,
            convert: a
        }
    }(), window.theme = window.theme || {}, window.slate = window.slate || {}, theme.Images = function() {
        return {
            preload: function(t, e) {
                "string" == typeof t && (t = [t]);
                for (var o = 0; o < t.length; o++) {
                    var a = t[o];
                    this.loadImage(this.getSizedImageUrl(a, e))
                }
            },
            loadImage: function(t) {
                (new Image).src = t
            },
            switchImage: function(t, e, o) {
                var a = this.imageSize(e.src),
                    n = this.getSizedImageUrl(t.src, a);
                o ? o(n, t, e) : e.src = n
            },
            imageSize: function(t) {
                var e = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                return null !== e ? e[1] : null
            },
            getSizedImageUrl: function(t, e) {
                if (null == e) return t;
                if ("master" === e) return this.removeProtocol(t);
                var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null != o) {
                    var a = t.split(o[0]),
                        n = o[0];
                    return this.removeProtocol(a[0] + "_" + e + n)
                }
                return null
            },
            removeProtocol: function(t) {
                return t.replace(/http(s)?:/, "")
            }
        }
    }(), theme.Currency = function() {
        var t = "${{amount}}";
        return {
            formatMoney: function(e, o) {
                "string" == typeof e && (e = e.replace(".", ""));
                var a = "",
                    n = /\{\{\s*(\w+)\s*\}\}/,
                    i = o || t;

                function r(t, e, o, a) {
                    if (e = slate.utils.defaultTo(e, 2), o = slate.utils.defaultTo(o, ","), a = slate.utils.defaultTo(a, "."), isNaN(t) || null == t) return 0;
                    var n = (t = (t / 100).toFixed(e)).split(".");
                    return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (n[1] ? a + n[1] : "")
                }
                switch (i.match(n)[1]) {
                    case "amount":
                        a = r(e, 2);
                        break;
                    case "amount_no_decimals":
                        a = r(e, 0);
                        break;
                    case "amount_with_comma_separator":
                        a = r(e, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        a = r(e, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        a = r(e, 0, " ")
                }
                return i.replace(n, a)
            }
        }
    }(), slate.utils = {
        findInstance: function(t, e, o) {
            for (var a = 0; a < t.length; a++)
                if (t[a][e] === o) return t[a]
        },
        removeInstance: function(t, e, o) {
            for (var a = t.length; a--;)
                if (t[a][e] === o) {
                    t.splice(a, 1);
                    break
                } return t
        },
        compact: function(t) {
            for (var e = -1, o = null == t ? 0 : t.length, a = 0, n = []; ++e < o;) {
                var i = t[e];
                i && (n[a++] = i)
            }
            return n
        },
        defaultTo: function(t, e) {
            return null == t || t != t ? e : t
        }
    }, slate.Variants = function() {
        function t(t) {
            this.$container = t.$container, this.product = t.product, this.singleOptionSelector = t.singleOptionSelector, this.originalSelectorId = t.originalSelectorId, this.enableHistoryState = t.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
        }
        return t.prototype = $.extend({}, t.prototype, {
            _getCurrentOptions: function() {
                var t = $.map($(this.singleOptionSelector, this.$container), function(t) {
                    var e = $(t),
                        o = e.attr("type"),
                        a = {};
                    return "radio" === o || "checkbox" === o ? !!e[0].checked && (a.value = e.val(), a.index = e.data("index"), a) : (a.value = e.val(), a.index = e.data("index"), a)
                });
                return t = slate.utils.compact(t)
            },
            _getVariantFromOptions: function() {
                var t = this._getCurrentOptions(),
                    e = this.product.variants,
                    o = !1;
                return e.forEach(function(e) {
                    var a = !0;
                    e.options;
                    t.forEach(function(t) {
                        a && (a = t.value === e[t.index])
                    }), a && (o = e)
                }), o || null
            },
            _onSelectChange: function() {
                var t = this._getVariantFromOptions();
                this.$container.trigger({
                    type: "variantChange",
                    variant: t
                }), t && (this._updateMasterSelect(t), this._updateImages(t), this._updatePrice(t), this._updateSKU(t), this.currentVariant = t, this.enableHistoryState && this._updateHistoryState(t))
            },
            _updateImages: function(t) {
                var e = t.featured_image || {},
                    o = this.currentVariant.featured_image || {};
                t.featured_image && e.src !== o.src && this.$container.trigger({
                    type: "variantImageChange",
                    variant: t
                })
            },
            _updatePrice: function(t) {
                t.price === this.currentVariant.price && t.compare_at_price === this.currentVariant.compare_at_price || this.$container.trigger({
                    type: "variantPriceChange",
                    variant: t
                })
            },
            _updateSKU: function(t) {
                t.sku !== this.currentVariant.sku && this.$container.trigger({
                    type: "variantSKUChange",
                    variant: t
                })
            },
            _updateHistoryState: function(t) {
                if (history.replaceState && t) {
                    var e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + t.id;
                    window.history.replaceState({
                        path: e
                    }, "", e)
                }
            },
            _updateMasterSelect: function(t) {
                $(this.originalSelectorId, this.$container)[0].value = t.id
            }
        }), t
    }(), $.fn.extend({
        productBox: function() {
            $(this).find(".box.product figure").on("click", function(t) {
                if ($(t.target).is(".vendor") || $(t.target).parent().is(".vendor"));
                else {
                    t.preventDefault();
                    var e = $(this).find("a").attr("href");
                    t.shiftKey || t.ctrlKey || t.metaKey ? window.open(e, "_blank") : window.location = e
                }
            }), $(this).find(".card__image").onCardAttrChange()
        },
        destroyProductBox: function() {
            $(this).find(".box.product figure").off("click"), $(this).find(".card__image").destroyCardAttrChange
        },
        onCardAttrChange: function() {
            $(this).attrchange({
                trackValues: !0,
                callback: function(t) {
                    if ("class" == t.attributeName) {
                        var e = $(t.target),
                            o = e.closest(".card__image-wrapper");
                        !e.hasClass("lazyloaded") || e.hasClass("lazyloading") || e.hasClass("card__image-loaded") || (e.addClass("card__image-loaded").removeClass("card__image"), o.addClass("card__image-wrapper-loaded").removeClass("card__image-wrapper"), o.css({
                            "padding-top": "0px"
                        }), $.fn.matchHeight._update())
                    }
                }
            })
        },
        destroyCardAttrChange: function() {
            $(this).attrchange("remove")
        }
    }), StyleHatch.refreshFixTo = function() {
        StyleHatch.Promos.refreshFixTo(), $("*").filter(function() {
            return $(this).data("fixtoInstance")
        }).each(function(t) {
            $(this).data("fixto-instance")._running && $(this).fixTo("refresh")
        })
    }, StyleHatch.videoLayout = function() {
        //$(".rte").fitVids()
    }, StyleHatch.loginForms = function() {
        function t() {
            StyleHatch.cache.$recoverPasswordForm.show(), StyleHatch.cache.$customerLoginForm.hide()
        }
        StyleHatch.cache.$recoverPasswordLink.on("click", function(e) {
            e.preventDefault(), t(), StyleHatch.updateHash("recover")
        }), StyleHatch.cache.$hideRecoverPasswordLink.on("click", function(t) {
            t.preventDefault(), StyleHatch.cache.$recoverPasswordForm.hide(), StyleHatch.cache.$customerLoginForm.show(), StyleHatch.updateHash()
        }), "#recover" == StyleHatch.getHash() && t()
    }, StyleHatch.initTemplates = function() {
        switch (StyleHatch.cache.$body.data("template")) {
            case "addresses":
                StyleHatch.initCustomerAddressTemplate()
        }
    }, StyleHatch.initCustomerAddressTemplate = function() {
        StyleHatch.addressJSValidation && $('.customer-address input[type="submit"]').on("click", function(t) {
            var e = $(this).closest("form"),
                o = e.find('input[name="address[last_name]"]'),
                a = e.find('input[name="address[address1]"]'),
                n = e.find('input[name="address[city]"]'),
                i = e.find('select[name="address[country]"]'),
                r = e.find('select[name="address[province]"]'),
                c = e.find('input[name="address[zip]"]');
            o.val() || o.addClass("required"), a.val() || a.addClass("required"), n.val() || n.addClass("required"), "---" == i.val() && i.addClass("required"), r.closest(".input-row").is(":visible") && (r.val() && "---" != r.val() && "" != r.val() || r.addClass("required")), c.val() || c.addClass("required");
            var s = e.find("input.required, select.required");
            s.on("focus", function() {
                $(this).removeClass("required")
            }), s.length > 0 ? (e.find("div.errors").parent().show(), t.preventDefault()) : e.find("div.errors").parent().hide()
        })
    }, StyleHatch.updateHash = function(t) {
        t ? (window.location.hash = "#" + t, $("#" + t).attr("tabindex", -1).focus()) : window.location.hash = ""
    }, StyleHatch.getHash = function() {
        return window.location.hash
    }, StyleHatch.quantitySelect = function() {
        $(".quantity-select").each(function() {
            var t = $(this),
                e = t.find(".adjust-minus"),
                o = t.find(".adjust-plus"),
                a = t.find("input.quantity"),
                n = a.val();
            e.on("click", function(t) {
                (n = a.val()) > 1 && (n--, a.val(n)), $(this).parent().parent().siblings('.error').removeClass('active'), t.preventDefault()
            }), o.on("click", function(t) {
                n = a.val(), n++, a.val(n), t.preventDefault()
            })

            o.on("click", function(t) {
                n = Number(a.val());
                var max = Number(a.attr('data-inventory'));
                
                if (n > max && t.keyCode !== 46 && t.keyCode !== 8) {
                    a.val(max);
                    $(this).parent().parent().siblings('.error').addClass('active');
                } else {
                    $(this).parent().parent().siblings('.error').removeClass('active');
                }
                t.preventDefault()
            })





        })
    }, StyleHatch.resetPasswordSuccess = function() {
        StyleHatch.cache.$passwordResetSuccess.show()
    }, window.Adreno = window.Adreno || {}, Adreno.mobileMenuHeight = function() {
        var t = $("nav#menu");
        t.css("height", window.innerHeight), $(window).resize(function() {
            t.css("height", window.innerHeight)
        })
    }, Adreno.authCourierCartMessage = function() {
        var t = $(".template-cart");
        if (t.length) {
            var e = t.find(".courier-auth input"),
                o = t.find(".cart-notes textarea");
            if (e.length) {
                var a = t.find(".courier-auth input:checked").parent().text();
                o.val(a), e.on("change", function() {
                    var t = o.text(),
                        e = $(this).parent().text();
                    t = $(this).is(":checked") ? e : "", o.val(t)
                })
            }
        }
    }, $(document).ready(function() {
        StyleHatch.init(), Adreno.authCourierCartMessage()
    })
}();